import { ChangeDetectionStrategy, Component, Inject, OnInit, OnChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash';

import { IGlobalProblemSubtype } from '../../../../interfaces/global-problem-subtype.interface';
import { CheckListsValidators } from '../../../../check-lists.validators';
import { HDTicketTypesToken } from '../../check-lists.constant';

@Component({
  selector: 'app-create-global-checklist-dialog',
  templateUrl: './create-global-checklist-dialog.component.html',
  styleUrls: ['./create-global-checklist-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateGlobalChecklistDialogComponent implements OnInit, OnChanges {
  form: UntypedFormGroup = this.fb.group({
    name: ['', Validators.required],
    gpSubtypes: [[], CheckListsValidators.requiredArray],
  });

  selectedGPSubtypes: IGlobalProblemSubtype[];
  transformedGpSubtypes: IGlobalProblemSubtype[] = [];
  cloneDeep = cloneDeep;
  selectedSubtypes: IGlobalProblemSubtype[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    @Inject(HDTicketTypesToken) public gpSubtypes: IGlobalProblemSubtype[]
  ) {}

  ngOnInit(): void {
    this.selectedGPSubtypes = [];
    this.transformedGpSubtypes = this.transformGPSubtypes(this.gpSubtypes);
    this.transformedGpSubtypes.sort((a, b) => this.sortBySelected(a, b));
  }

  ngOnChanges(changes) {
    if (changes.gpSubtypes && changes.gpSubtypes.currentValue) {
      this.transformedGpSubtypes = this.transformGPSubtypes(changes.gpSubtypes.currentValue);
      this.transformedGpSubtypes.sort((a, b) => this.sortBySelected(a, b));
    }
  }

  transformGPSubtypes(subtypes: (IGlobalProblemSubtype & { checked?: boolean })[]): any[] {
    if (!subtypes || !subtypes.length) {
      return [];
    }

    const subtypeGroups = new Map<string, (IGlobalProblemSubtype & { checked?: boolean })[]>();
    subtypes.forEach((subtype) => {
      const key = subtype.subtype;
      if (!subtypeGroups.has(key)) {
        subtypeGroups.set(key, []);
      }
      subtypeGroups.get(key).push(subtype);
    });

    const uniqueSubtypes = Array.from(subtypeGroups.values()).map((group) => {
      return group.find((item) => item.checked) || group[0];
    });

    return uniqueSubtypes.map((subtype) => ({
      ...subtype,
      name: subtype.subtype,
    }));
  }

  handleSubmit(): void {
    this.activeModal.close(this.form.value);
  }

  sortBySelected(a: any, b: any): number {
    if (a.checked !== b.checked) {
      return a.checked ? -1 : 1;
    }
    return a.name.localeCompare(b.name);
  }

  handleChangeSubtype(gpSubtypes: IGlobalProblemSubtype[]): void {
    if (!gpSubtypes) {
      return;
    }

    this.selectedSubtypes = gpSubtypes;

    this.transformedGpSubtypes = this.transformedGpSubtypes.map((tt) => ({
      ...tt,
      checked: gpSubtypes.some((selected) => selected.id === tt.id),
    }));
    this.transformedGpSubtypes.sort((a, b) => this.sortBySelected(a, b));

    this.form.patchValue({
      gpSubtypes: gpSubtypes.map((tt) => tt && tt.id).filter((id) => id !== undefined),
    });
  }
}
